import { ActivationStatus, OrgActivationStatus } from "@humanex/interfaces";

import { useActivateOrg } from "@/hooks/queries/use-org-query";

interface OrgActivationPageProps {
  orgId: string;
  orgName: string;
  activationStatus: OrgActivationStatus;
}

const BASIC_PLAN = "basic";

export function OrgActivationPage({ orgId, orgName, activationStatus }: OrgActivationPageProps) {
  const activateMutation = useActivateOrg();

  if (activationStatus.status === ActivationStatus.ACTIVE) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="bg-white border border-gray-200 rounded-2xl p-8 max-w-md text-center">
          <p className="text-xl font-semibold text-primary-700 mb-2">Tổ chức đã được kích hoạt</p>
          <p className="text-slate-500 text-sm">
            {orgName} đang hoạt động với gói{" "}
            <span className="font-medium text-primary-700">{activationStatus.plan ?? BASIC_PLAN}</span>.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-full">
      <div className="bg-white border border-gray-200 rounded-2xl p-8 max-w-md w-full">
        <p className="text-xl font-semibold text-primary-700 mb-1">{orgName}</p>
        <p className="text-slate-500 text-sm mb-6">Tổ chức chưa được kích hoạt</p>

        <p className="text-sm font-medium text-primary-700 mb-3">Chọn gói dịch vụ</p>

        {/* Plan card — Basic (only option) */}
        <div className="border-2 border-primary-200 rounded-xl p-4 mb-6 bg-primary-50">
          <div className="flex items-center justify-between mb-2">
            <span className="font-semibold text-primary-700">Basic</span>
            <span className="text-green-600 font-bold">Miễn phí</span>
          </div>
          <ul className="space-y-1.5 text-xs text-slate-500">
            <li className="flex items-center gap-2">
              <span className="text-green-500">✓</span> 3 chương trình
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-500">✓</span> Quản lý ứng viên cơ bản
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-500">✓</span> Hỗ trợ email
            </li>
          </ul>
        </div>

        <div className="flex flex-col gap-2">
          <button
            onClick={() => activateMutation.mutate({ orgId, plan: BASIC_PLAN })}
            disabled={activateMutation.isPending}
            className="w-full py-2.5 text-sm bg-primary-500 hover:bg-primary-600 text-white rounded-lg disabled:opacity-40 font-medium transition-colors"
          >
            {activateMutation.isPending ? "Đang xử lý..." : "Kích hoạt ngay"}
          </button>

          {activateMutation.isError && (
            <p className="text-xs text-red-500 text-center">
              Có lỗi xảy ra. Vui lòng thử lại hoặc liên hệ hỗ trợ.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
